export const Config = {
    scheme: 'https',
    host: 'vidyapeeth.penpencil.co'
}